/* eslint-disable react/prop-types */
import React from "react";

const SquareCheckBox = (props) => {
  const { id, value, name, checked, onChange, labelName, disabled } = props;
  return (
    <label className="form-check-label cursor-pointer">
      <input
        id={id}
        type="checkbox"
        value={value}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="form-check-input"
      />
      <span className="ms-2">{labelName}</span>
    </label>
  );
};
export default SquareCheckBox;
